// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5648":"f97c888ca239b026","6401":"4efe9d5dca467492","7787":"db90672f38e66f54"}[chunkId] + ".css";
};